import { Layer } from "react-map-gl/mapbox";

export default function CustomLayers({ source }: { source: string }) {
  return (
    <>
      <Layer
        id={`${source}-circles`}
        type="circle"
        source={source}
        filter={["in", ["geometry-type"], ["literal", ["Point", "MultiPoint"]]]}
        paint={{
          "circle-color": "#2eb88a",
          "circle-radius": 8,
          "circle-stroke-color": "#fff",
          "circle-stroke-width": 1.5,
        }}
      />
      <Layer
        id={`${source}-lines`}
        type="line"
        source={source}
        paint={{
          "line-color": "#888",
          "line-width": 4,
        }}
        layout={{
          "line-z-offset": [
            "at-interpolated",
            [
              "*",
              ["line-progress"],
              ["-", ["length", ["get", "elevation"]], 1],
            ],
            ["get", "elevation"],
          ],
          "line-elevation-reference": "ground",
        }}
      />
      <Layer
        id={`${source}-labels`}
        type="symbol"
        source={source}
        layout={{
          "text-field": ["get", "map::label"],
          "text-offset": [0, 1.25],
          "text-anchor": "top",
        }}
      />
    </>
  );
}
